import { useContext } from 'react';

import { DataContext } from 'providers/data';

import Modals from 'components/views/Modals';
import { Box, Typography } from '@mui/material';
import { ButtonOutlined, ButtonRectangle } from 'components/views/form/Button';

type ParamsClub = {
    openModal: boolean;
    handleClickClosed: () => void;
}

const ModalClube = ({ openModal, handleClickClosed }: ParamsClub) => {
    const { handleGetUrlAdvantagesClub } = useContext(DataContext);

    return (
        <Modals open={openModal}>
            <Box sx={{ textAlign: 'center', width: { xs: 'calc(100vw - 2rem)', md: '23.31rem' } }}>
                <Box sx={{ borderRadius: '8px 8px 0 0' }} padding='1.625rem 0 1.125rem'>
                    <Typography fontSize='1.5625rem' fontWeight={700}>
                        Descontos
                    </Typography>
                    <Typography fontSize='1rem' lineHeight='21px' paddingTop='.625rem'>
                        O link será aberto em uma nova aba.
                        <br />
                        Deseja continuar?
                    </Typography>
                </Box>
                <Box sx={{
                    borderRadius: '0 0 8px 8px',
                    padding: '1.875rem 3.81rem 1.75rem',
                    backgroundColor: 'primary.main',
                    'button': {
                        width: '100%',
                        height: '2.5rem',
                    }
                }}>
                    <ButtonRectangle name='CONTINUAR' onClick={() => { handleGetUrlAdvantagesClub(); handleClickClosed(); }} />
                    <Box sx={{ 'button': { borderColor: '#F9FCFF', color: '#F9FCFF', ':hover': { borderColor: '#F9FCFF', color: '#F9FCFF' } }, marginTop: '.875rem' }}>
                        <ButtonOutlined name='CANCELAR' onClick={() => handleClickClosed()} />
                    </Box>
                </Box>
            </Box>
        </Modals>
    )
}

export default ModalClube;